import {createApp, reactive} from 'vue'
import App from './App.vue'
import * as VueRouter from 'vue-router'

import WelcomePage from './pages/WelcomePage.vue';
import DashboardPage from "@/pages/DashboardPage.vue";
import NotFoundPage from "@/pages/NotFoundPage.vue";
import AdminFilms from "@/pages/admin/AdminFilms.vue";
import SearchPage from "@/pages/SearchPage.vue";
import SearchResultsPage from "@/pages/SearchResultsPage.vue";
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import ViewingOptionsPage from "@/pages/ViewingOptionsPage.vue";
import ProfilePage from "@/pages/ProfilePage.vue";
import AdminPage from "@/pages/AdminPage.vue";
import AdminUsersPage from "@/pages/admin/AdminUsersPage.vue";
import SetCategoryWinnersPage from "@/pages/admin/SetCategoryWinnersPage.vue";
import FriendsPage from "@/pages/friends/FriendsPage.vue";
import FriendConnectPage from "@/pages/friends/FriendConnectPage.vue";
import {userStore} from "@/userStore";
import axios from "axios";
import AboutPage from "@/pages/AboutPage.vue";
import ChecklistPage from "@/pages/ChecklistPage.vue";
import ResetPasswordPage from "@/pages/ResetPasswordPage.vue";
import SettingsPage from "@/pages/SettingsPage.vue";
import LogInPage from "@/pages/LogInPage.vue";
import AdminMacrodataRefinement from "@/pages/admin/AdminMacrodataRefinement.vue";
import AdminEditFilm from "@/pages/admin/AdminEditFilm.vue";
import ContactUsPage from "@/pages/ContactUsPage.vue";
import AdminUserPage from "@/pages/admin/AdminUserPage.vue";
import analytics from "@/analytics";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage.vue";
import Bugsnag from '@bugsnag/js'
import LetterboxdPage from "@/pages/LetterboxdPage.vue";
import AdminServerInfoPage from "@/pages/admin/AdminServerInfoPage.vue";
import AdminTestStorefront from "@/pages/admin/AdminTestStorefront.vue";
//import AdminTestStripeReturn from "@/pages/admin/stripe/AdminTestStripeReturn.vue";
import AdminTestPurchaseResolved from "@/pages/admin/AdminTestPurchaseResolved.vue";
import MembershipPage from "@/pages/membership/MembershipPage.vue";
import AdminSSE from "@/pages/admin/AdminSSE.vue";
import AdminFriendGraphPage from "@/pages/admin/AdminFriendGraphPage.vue";
import AdminStreamingProvidersPage from "@/pages/admin/AdminStreamingProvidersPage.vue"
import ClubsPage from "@/pages/clubs/ClubsPage.vue";
import CreateClubPage from "@/pages/clubs/CreateClubPage.vue";
import ClubProfilePage from "@/pages/clubs/ClubProfilePage.vue";
import ClubJoinPage from "@/pages/clubs/ClubJoinPage.vue";
import EditClubPage from "@/pages/clubs/EditClubPage.vue";
import OscarPoolBallotPage from "@/pages/clubs/oscar pool/OscarPoolBallotPage.vue";
import OscarPoolSetupPage from "@/pages/clubs/oscar pool/OscarPoolSetupPage.vue";
import OscarPoolResultsPage from "@/pages/clubs/oscar pool/OscarPoolResultsPage.vue";
import AboutOscarPoolsPage from "@/pages/clubs/oscar pool/AboutOscarPoolsPage.vue";
import FamilyMembershipJoinPage from "@/pages/membership/FamilyMembershipJoinPage.vue";
import AdminClubGraphPage from "@/pages/admin/AdminClubGraphPage.vue";
import AdminMonitorOscarPoolEventStreams from "@/pages/admin/AdminMonitorOscarPoolEventStreams.vue";

//const GTAG_ID = 'G-8F170E7THW'

const router = VueRouter.createRouter({
    history: VueRouter.createWebHistory(),
    routes: [{
        path: '/',
        redirect: homePageRedirect
    }, {
        name: "WelcomePage",
        path: '/welcome',
        component: WelcomePage,
        beforeEnter: [requireNoUser],
    }, {
        name: "SignUpPage",
        meta: { pageTitle: 'Sign Up' },
        path: '/sign-up',
        component: LogInPage,
        beforeEnter: [requireNoUser, keepQueryParams]
    }, {
        name: "LogInPage",
        meta: { pageTitle: 'Log In' },
        path: '/log-in',
        component: LogInPage,
        beforeEnter: [requireNoUser, keepQueryParams]
    }, {
        name: "ResetPasswordPage",
        meta: { pageTitle: 'Reset Password' },
        path: '/reset-password',
        component: ResetPasswordPage,
        beforeEnter: [preferUser],
    }, {
        name: "AboutPage",
        meta: { pageTitle: 'About myOscarList' },
        path: '/about',
        component: AboutPage,
        beforeEnter: [preferUser],
    }, {
        name: "PrivacyPolicyPage",
        meta: { pageTitle: 'Privacy Policy' },
        path: '/privacy',
        component: PrivacyPolicyPage,
        beforeEnter: [preferUser],
    }, {
        name: "AuthComplete",
        path: '/auth-complete',
        redirect: authCompleteRedirect
    }, {
        name: "DashboardPage",
        meta: { pageTitle: 'Dashboard' },
        path: '/dashboard',
        component: DashboardPage,
        beforeEnter: [requireUser],
    }, {
        name: "ProfilePage",
        meta: { pageTitle: 'Profile' },
        path: '/profile/:user_id',
        component: ProfilePage,
        beforeEnter: [preferUser],// requirePermissionToSeeProfile],
        props: true
    }, {
        name: "SettingsPage",
        meta: { pageTitle: 'Settings' },
        path: '/settings',
        component: SettingsPage,
        beforeEnter: [requireUser],
    }, {
        name: "LetterboxdPage",
        meta: { pageTitle: 'Import From Letterboxd' },
        path: '/letterboxd',
        component: LetterboxdPage,
        beforeEnter: [requireUser],
    }, {
        name: "ChecklistPage",
        meta: { pageTitle: 'Checklist' },
        path: '/checklist/:init_ceremony?',
        component: ChecklistPage,
        beforeEnter: [requireUser],
        props: true
    }, {
        name: "ViewingOptionsPage",
        meta: { pageTitle: 'Viewing Options' },
        path: '/viewing-options',
        component: ViewingOptionsPage,
        beforeEnter: [requireUser],
    }, {
        name: "SearchPage",
        meta: { pageTitle: 'Search' },
        path: '/search',
        component: SearchPage,
        beforeEnter: [requireUser],
    }, {
        name: "SearchResultsPage",
        meta: { pageTitle: 'Search' },
        path: '/search-results',
        component: SearchResultsPage,
        beforeEnter: [requireUser],
    }, {
        name: "ContactUsPage",
        meta: { pageTitle: 'Contact Us' },
        path: '/contact-us',
        component: ContactUsPage,
        beforeEnter: [preferUser],
    },

    // membership pages
    {
        name: "MembershipPage",
        meta: { pageTitle: 'Membership' },
        path: '/membership',
        component: MembershipPage,
        beforeEnter: [requireUser],
    }, {
        name: "FamilyMembershipJoinPage",
        meta: { pageTitle: 'Family Membership' },
        path: '/family-membership-invite/:subscription_id/:invite_code',
        component: FamilyMembershipJoinPage,
        beforeEnter: [preferUser],
        props: true,
    },

    // friends pages
    {
        name: "FriendsPage",
        meta: { pageTitle: 'Friends' },
        path: '/friends',
        component: FriendsPage,
        beforeEnter: [requireUser],
    }, {
        name: "FriendConnectPage",
        meta: { pageTitle: 'Connect With Friend' },
        path: '/connect-with/:user_id_to_connect_with',
        component: FriendConnectPage,
        beforeEnter: [preferUser],
        props: true
    },

    // club pages
    {
        name: "ClubsPage",
        meta: { pageTitle: 'Clubs' },
        path: '/clubs',
        component: ClubsPage,
        beforeEnter: [requireUser],
    }, {
        name: "CreateClubPage",
        meta: { pageTitle: 'Create Club' },
        path: '/create-club',
        component: CreateClubPage,
        beforeEnter: [requireUser],
    }, {
        name: "ClubProfilePage",
        meta: { pageTitle: 'Club Profile' },
        path: '/club/:club_id',
        component: ClubProfilePage,
        beforeEnter: [requireUser],
        props: true
    }, {
        name: "ClubJoinPage",
        meta: { pageTitle: 'Join Club' },
        path: '/join-club/:club_id',
        component: ClubJoinPage,
        beforeEnter: [preferUser],
        props: true
    }, {
        name: "EditClubPage",
        meta: { pageTitle: 'Edit Club' },
        path: '/edit-club/:club_id',
        component: EditClubPage,
        beforeEnter: [requireUser],
        props: true
    }, {
        name: "ClubMemberProfilePage",
        meta: { pageTitle: 'Member Profile' },
        path: '/club/:club_id/member/:user_id',
        component: ProfilePage,
        beforeEnter: [requireUser], // todo: add a 'belongs to this club' nav guard?
        props: true
    }, {
        name: "OscarPoolSetupPage",
        meta: { pageTitle: 'Oscar Pool Setup' },
        path: '/club/:club_id/oscar-pool-setup',
        component: OscarPoolSetupPage,
        beforeEnter: [requireUser], // todo: add a 'belongs to this club' nav guard?
        props: true
    }, {
        name: "OscarPoolBallotPage",
        meta: { pageTitle: 'Oscar Pool Ballot' },
        path: '/club/:club_id/oscar-pool-ballot/:oscar_pool_id',
        component: OscarPoolBallotPage,
        beforeEnter: [requireUser], // todo: add a 'belongs to this club' nav guard?
        props: true
    }, {
        name: "OscarPoolResultsPage",
        meta: { pageTitle: 'Oscar Pool Results' },
        path: '/club/:club_id/oscar-pool-results/:ceremony',
        component: OscarPoolResultsPage,
        beforeEnter: [requireUser], // todo: add a 'belongs to this club' nav guard?
        props: true
    },

    // oscar pool pages (some same as clubs pages, with different routes)
    {
        name: "OscarPoolsPage",
        meta: { pageTitle: 'Oscar Pools' },
        path: '/oscar-pools',
        component: ClubsPage,
        beforeEnter: [requireUser],
    }, {
        name: "CreateOscarPoolPage",
        meta: { pageTitle: 'Create Oscar Pool' },
        path: '/create-oscar-pool',
        component: CreateClubPage,
        beforeEnter: [requireUser],
    }, {
        name: "OscarPoolProfilePage",
        meta: { pageTitle: 'Oscar Pool Profile' },
        path: '/oscar-pool/:club_id',
        component: ClubProfilePage,
        beforeEnter: [requireUser],
        props: true
    }, {
        name: "OscarPoolJoinPage",
        meta: { pageTitle: 'Join Oscar Pool' },
        path: '/join-oscar-pool/:club_id',
        component: ClubJoinPage,
        beforeEnter: [preferUser],
        props: true
    }, {
        name: "EditOscarPoolPage",
        meta: { pageTitle: 'Edit Oscar Pool' },
        path: '/edit-oscar-pool/:club_id',
        component: EditClubPage,
        beforeEnter: [requireUser],
        props: true
    }, {
        name: "OscarPoolMemberProfilePage",
        meta: { pageTitle: 'Member Profile' },
        path: '/oscar-pool/:club_id/member/:user_id',
        component: ProfilePage,
        beforeEnter: [requireUser], // todo: add a 'belongs to this club' nav guard?
        props: true
    }, {
        name: "AboutOscarPoolsPage",
        meta: { pageTitle: 'About myOscarList Oscar Pools' },
        path: '/oscar-pool/about',
        component: AboutOscarPoolsPage,
        beforeEnter: [preferUser],
    }, {
        name: "OscarPoolSetupPage",
        meta: { pageTitle: 'Oscar Pool Setup' },
        path: '/oscar-pool/:club_id/oscar-pool-setup',
        component: OscarPoolSetupPage,
        beforeEnter: [requireUser], // todo: add a 'belongs to this club' nav guard?
        props: true
    }, {
        name: "OscarPoolBallotPage",
        meta: { pageTitle: 'Oscar Pool Ballot' },
        path: '/oscar-pool/:club_id/oscar-pool-ballot/:oscar_pool_id',
        component: OscarPoolBallotPage,
        beforeEnter: [requireUser], // todo: add a 'belongs to this club' nav guard?
        props: true
    }, {
        name: "OscarPoolResultsPage",
        meta: { pageTitle: 'Oscar Pool Results' },
        path: '/oscar-pool/:club_id/oscar-pool-results/:ceremony',
        component: OscarPoolResultsPage,
        beforeEnter: [requireUser], // todo: add a 'belongs to this club' nav guard?
        props: true
    },

    // adnim pages
    {
        name: "AdminPage",
        meta: { pageTitle: 'Admin Menu' },
        path: '/admin',
        component: AdminPage,
        beforeEnter: [requireAdmin],
    }, {
        name: "AdminUsersPage",
        meta: { pageTitle: 'Admin: Users List' },
        path: '/admin/users',
        component: AdminUsersPage,
        beforeEnter: [requireAdmin],
    }, {
        name: "AdminUserPage",
        meta: { pageTitle: 'Admin: User View' },
        path: '/admin/user/:user_id',
        component: AdminUserPage,
        beforeEnter: [requireAdmin],
        props: true
    }, {
        name: "SetCategoryWinnersPage",
        meta: { pageTitle: 'Admin: Set Category Winners' },
        path: '/admin/set-category-winners/:ceremony_num',
        component: SetCategoryWinnersPage,
        beforeEnter: [requireAdmin],
        props: true
    }, {
        name: "AdminMonitorOscarPoolEventStreams",
        meta: { pageTitle: 'Admin: Monitor OscarPool Event Streams' },
        path: '/admin/monitor-oscarpool-event-streams',
        component: AdminMonitorOscarPoolEventStreams,
        beforeEnter: [requireAdmin],
        props: true
    }, {
        name: "AdminMacrodataRefinement",
        meta: { pageTitle: 'Admin: Macrodata Refinement' },
        path: '/admin/macrodata-refinement',
        component: AdminMacrodataRefinement,
        beforeEnter: [requireAdmin],
        props: true
    }, {
        name: "AdminEditFilm",
        meta: { pageTitle: 'Admin: Edit Film' },
        path: '/admin/edit-film/:filmId',
        component: AdminEditFilm,
        beforeEnter: [requireAdmin],
        props: true
    }, {
        name: "AdminServerInfoPage",
        meta: { pageTitle: 'Admin: Server Info' },
        path: '/admin/server-info',
        component: AdminServerInfoPage,
        beforeEnter: [requireAdmin],
        props: true
    }, {
        name: "AdminTestStorefront",
        meta: { pageTitle: 'Admin: Test Storefront' },
        path: '/admin/test-storefront',
        component: AdminTestStorefront,
        beforeEnter: [requireAdmin]
    }, {
        name: "AdminTestPurchaseResolved",
        meta: { pageTitle: 'Admin: Test Purchase Resolved' },
        path: '/admin/test-purchase-resolved',
        component: AdminTestPurchaseResolved,
        beforeEnter: [requireAdmin],
        props: true
    }, {
        name: "AdminFriendGraphPage",
        meta: { pageTitle: 'Admin: Friend Graph' },
        path: '/admin/friend-graph',
        component: AdminFriendGraphPage,
        beforeEnter: [requireAdmin]
    }, {
        name: "AdminClubGraphPage",
        meta: { pageTitle: 'Admin: Club Graph' },
        path: '/admin/club-graph',
        component: AdminClubGraphPage,
        beforeEnter: [requireAdmin]
    }, {
        path: '/admin/films/:year',
        meta: { pageTitle: 'Admin: Films' },
        component: AdminFilms,
        beforeEnter: [requireAdmin],
    }, {
        path: '/admin/sse-test',
        meta: { pageTitle: 'Admin: SSE Test' },
        component: AdminSSE,
        beforeEnter: [requireAdmin],
    }, {
        path: '/admin/streaming-providers',
        meta: { pageTitle: 'Admin: Streaming Providers' },
        component: AdminStreamingProvidersPage,
        beforeEnter: [requireAdmin],
    }, {
        name: "NotFoundPage",
        path: '/:pathMatch(.*)*',
        meta: { pageTitle: 'Page Not Found' },
        component: NotFoundPage,
        beforeEnter: [preferUser],
    }],

    scrollBehavior(to /*, from, savedPosition*/) {
        if (to.hash && to.hash.toLowerCase() !== '#top') {
            return {
                el: to.hash,
                behavior: 'instant',
                top: 100 // account for fixed nav bar
            };
        }
        return {
            top: 0,
            behavior: 'instant'
        };
    },
});

router.beforeEach(to => {

    //console.log(`beforeEach()`, to);

    // The welcome page uses the title defined in index.html
    if ( to.name === 'WelcomePage' ) {
        return;
    }
    // otherwise, at least use 'myOscarList'
    document.title = 'myOscarList';

    // add any pageTitle defined in metadata
    if ( to.meta?.pageTitle ) {
        document.title += ` - ${to.meta.pageTitle}`;

        if ( to.name === 'SearchResultsPage') {
            document.title += ` "${to.query.searchText.replace(/^./, char => char.toUpperCase())}"`; // capitalize first letter for nicer presentation as a page title
        }
    }
});

router.afterEach((to, from, failure) => {
    if (!failure) {
        // ChecklistPage sends extra info, so it's responsible for sending its own event
        if ( to.name !== "ChecklistPage" ) {
            analytics.sendPage(
                to.name,
                {
                    page_params: to.params,
                    page_query: to.query
                }
            );
        }
    }
})

// eslint-disable-next-line no-unused-vars
async function requireFullMembership(to) {

    if ( userStore.user ) {
        return userStore.isFullMember();
    }

    // console.log(`requireAdmin(${to.path}) - checking for login`);
    return axios
        .get("/api/user/profile")
        .then(response => {
            userStore.setUser(response.data.user);
            if ( !userStore.isFullMember() ) {
                return homePageRedirect();
            }
            return userStore.isFullMember();
        })
        .catch((/*error*/) => {
            userStore.setUser(null);
            return { name: 'WelcomePage' };
        });
}

async function requireAdmin(/*to*/) {

    if ( userStore.user ) {
        // console.log(`requireAdmin(${to.path}) - already have login`);
        // console.log(`requireAdmin(${to.path}) - isAdmin = ${userStore.isAdmin()}`);
        return userStore.isAdmin();
    }

    // console.log(`requireAdmin(${to.path}) - checking for login`);
    return axios
        .get("/api/user/profile")
        .then((response) => {
            userStore.setUser(response.data.user);
            // console.log(`requireAdmin(${to.path}) - logged in!`);
            // console.log(`requireAdmin(${to.path}) - isAdmin = ${userStore.isAdmin()}`);
            if ( !userStore.isAdmin() ) {
                return homePageRedirect();
            }
            return userStore.isAdmin();
        })
        .catch((/*error*/) => {
            //analytics.notifyBugsnagOfError(error);
            userStore.setUser(null);
            // console.log(`requireAdmin(${to.path}) - Not logged in.`);
            return { name: 'WelcomePage' };
        });
}

// eslint-disable-next-line no-unused-vars
async function requireTester(to) {

    if ( userStore.user ) {
        // console.log(`requireAdmin(${to.path}) - already have login`);
        // console.log(`requireAdmin(${to.path}) - isAdmin = ${userStore.isAdmin()}`);
        return userStore.isTester() ? true : homePageRedirect();
    }

    // console.log(`requireAdmin(${to.path}) - checking for login`);
    return axios
        .get("/api/user/profile")
        .then((response) => {
            userStore.setUser(response.data.user);
            // console.log(`requireAdmin(${to.path}) - logged in!`);
            // console.log(`requireAdmin(${to.path}) - isAdmin = ${userStore.isAdmin()}`);
            return userStore.isTester() ? true : homePageRedirect();
        })
        .catch((/* error */) => {
            //analytics.notifyBugsnagOfError(error);
            userStore.setUser(null);
            // console.log(`requireAdmin(${to.path}) - Not logged in.`);
            return { name: 'WelcomePage' };
        });
}

function homePageRedirect(/*to*/) {
    return (
        !userStore.isLoggedIn() ? {name: 'WelcomePage'} :
            userStore.isFullMember() ? {name: 'DashboardPage'} :
                {name: 'ChecklistPage'}
    );
}

function authCompleteRedirect(to) {

    // console.log(`authCompleteRedirect(${to.path}) - checking for login`);
    // console.log(to);

    if ( to.query?.success != 'true' ) {
        // console.log(`authCompleteRedirect() login failure; strategy=${to.query?.strategy ? to.query?.strategy : 'unknown'}`)
        return { name: 'WelcomePage', query: null }; // todo: we need an error page
    }

    if ( sessionStorage.redirectAfterLogin ) {
        const redirect = sessionStorage.redirectAfterLogin;
        delete sessionStorage.redirectAfterLogin;

        // console.log(`authCompleteRedirect() redirectAfterLogin: ${redirect}`)
        return { path: redirect, query: null };
    }

    // console.log(`authCompleteRedirect() redirect: DashboardPage`)
    return { name: 'WelcomePage', query: null }; // the Welcome page will redirect to where the user should go
}

async function preferUser(/* to */) {
    if ( userStore.user ) {
        return true;
    }

    return axios
        .get("/api/user/profile")
        .then((response) => {
            userStore.setUser(response.data.user);
            return true;
        })
        .catch((/* error */) => {
            userStore.setUser(null);
            return true;
        });
}

async function requireUser(/* to */) {
    if ( userStore.user ) {
        // console.log(`requireUser(${to.path}) - already have login`);
        return true;
    }

    // console.log(`requireUser(${to.path}) - checking for login`);
    return axios
        .get("/api/user/profile")
        .then((response) => {
            userStore.setUser(response.data.user);
            // console.log(`requireUser(${to.path}) - logged in!`);
            return true;
        })
        .catch((/* error */) => {
            //analytics.notifyBugsnagOfError(error);
            userStore.setUser(null);
            // console.log(`requireUser(${to.path}) - Not logged in.`);
            return { name: 'WelcomePage' };
        });
}

async function requireNoUser(/* to */) {
    if ( userStore.user ) {
        return homePageRedirect();
    }

    return axios
        .get("/api/user/profile")
        .then((response) => {
            userStore.setUser(response.data.user);
            return homePageRedirect();
        })
        .catch((/* error */) => {
            //analytics.notifyBugsnagOfError(error);
            userStore.setUser(null);
            return true;
        });
}

async function keepQueryParams(to, from) {

    Object.assign(to.query, from.query);
    return true;
}

// eslint-disable-next-line
async function requirePermissionToSeeProfile( to ) {

    if ( userStore.user ) {
        return userStore.hasPermissionToSeeProfile(to.params.user_id)? true : homePageRedirect();
    }

    return axios
        .get("/api/user/profile")
        .then((response) => {
            userStore.setUser(response.data.user);
            return userStore.hasPermissionToSeeProfile(to.params.user_id)? true : homePageRedirect();
        })
        .catch((/* error */) => {
            userStore.setUser(null);
            return { name: 'WelcomePage' };
        });
}

const app = createApp(App);

app.config.globalProperties.$imagePathBase = process.env.BASE_URL;
app.config.globalProperties.$imagePathS3 = `https://myoscarlist.s3.us-east-2.amazonaws.com/public/`;
app.config.globalProperties.$serverInfo = reactive({ version: null, environment: null, startupTime: null } );
app.config.globalProperties.$apiPath = (
    location.origin
);

app.config.globalProperties.$screenshotMode = false;
app.config.globalProperties.$screenshotModeSettings = {
    modalsDisplayedAtTop: true,
    modalsDisplayedWithSolidBackdrop: true,
    modalsDisplayedWithoutCloseButton: true,
    disableToastNotifications: true,
    hideChecklistCeremonyOverlay: true,
    playCheckboxSound: false,
    hoverToRevealNavbar: false,
    hoverToRevealCeremonyNavbar: false,
    dontCrossOffViewedFilms: true,

    // UNCOMMENT TO LIMIT FILMS SHOWN ON VIEWING OPTIONS PAGE
    //viewingOptionsYearRange: [1928, 1952], // classic hollywood
    //viewingOptionsYearRange: [1948, 1965], // post studio system
    //viewingOptionsYearRange: [1965, 1980], // new hollywood
    //viewingOptionsYearRange: [1978, 2000], // bloockbusters
    //viewingOptionsYearRange: [2016, 2026], // current
    //viewingOptionsYearRange: [2030, 2031], // none
};


app.config.globalProperties.$colorTheme = {
    getStoredTheme: function () { return localStorage.getItem('color-theme') || 'auto' },
    getSystemTheme: function () {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    },
    getPreferredTheme: function () {
        return this.getStoredTheme() || this.getSystemTheme();
    },

    //setStoredTheme: function (theme) { localStorage.setItem('color-theme', theme) },
    setTheme: function (theme) {

        // only respect meaningful theme args
        if ( ['light', 'dark', 'auto'].includes(theme) ) {
            localStorage.setItem('color-theme', theme);
            document.documentElement.setAttribute(
                'data-bs-theme',
                (theme === 'auto') ? this.getSystemTheme() : theme
            );
        }
    }
}


function setServerInfoFromResponse(res) {
    if ( res?.headers?.['x-mol-server-build-version'] ) {
        app.config.globalProperties.$serverInfo.version = res.headers['x-mol-server-build-version'];
        app.config.globalProperties.$serverInfo.environment = res.headers['x-mol-server-environment'];
        //app.config.globalProperties.$serverInfo.startupTime = res.headers['x-mol-server-startup-timestamp'];
        app.config.globalProperties.$serverInfo.database = res.headers['x-mol-server-database'];
    }
}


function enforceMinimumFrontendVersion(res) {
    const currentVersion = document?.documentElement?.dataset?.molFrontendBuildVersion;
    const minExpectedVersion = res?.headers?.['x-mol-minimum-required-frontend-build-version'];
    if ( currentVersion && minExpectedVersion && (currentVersion < minExpectedVersion) ) {
        window.location.reload();
    }
}

// set some global axios properties
axios.defaults.baseURL = app.config.globalProperties.$apiPath;
axios.defaults.withCredentials = true;
axios.interceptors.response.use(res => {
    setServerInfoFromResponse(res);
    enforceMinimumFrontendVersion(res);
    return res;
    }, err => {
    setServerInfoFromResponse(err.response);
    enforceMinimumFrontendVersion(err.response);
    return Promise.reject(err);
});

app.use(router)
    // .use(VueGtag, {
    //         config: { id: GTAG_ID },
    //         onBeforeTrack () {
    //             verifyGtagUser();
    //         },
    //     }, router)
    .use(Bugsnag.getPlugin('vue'));

// wait until the router is ready to mount the app
router.isReady()
    .then(() => app.mount('#app'));